import { backgroundStyles } from 'styles/theme';
import styled from '@emotion/styled';

export default styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  backgroundColor: backgroundStyles.colors.secondary,
});
